import type { StayStatus } from "./scheduleModel";

export type ScheduleReservationAction = "check_in" | "follow_up" | "profile" | "reschedule";

export function actionForReservationStatus(status: StayStatus): ScheduleReservationAction {
  if (status === "reserved") return "check_in";
  if (status === "checked_in") return "follow_up";
  return "profile";
}

/** Só diária ainda reservada pode mudar de data; check-in feito é história. */
export function rescheduleAvailableForStatus(status: StayStatus): boolean {
  return status === "reserved";
}
